export default defineNuxtRouteMiddleware(async to => {
  if (to.path === '/login') return
  if (!getSessionToken()) return navigateTo('/login')
  try {
    await apiFetch('/api/user', { retry: 0, timeout: 3000 })
  } catch {
    return navigateTo('/login')
  }
})
